import React from "react";
import { Container, Grid, Button, Box, Typography } from "@mui/material";
import "../styles/Section1.css";
import tele1 from "../assets/Images/tele1.png";
import tele2 from "../assets/Images/tele2.png";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const Section1 = ({ scrollToSection }) => {
  return (
    <Box className="hero-wrapper">
      <Container maxWidth="xl">
        <Grid container spacing={4} alignItems="center">
          {/* Left Column: Headline & Value Proposition */}
          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: { md: "580px" } }}>
              <div className="hero-badge">
                <ShieldOutlinedIcon sx={{ fontSize: 16 }} />
                <span>NIN-Verified Healthcare Platform</span>
              </div>

              <h1 className="hero-heading">
                Instant Healthcare & Consultations —{" "}
                <span className="hero-highlight">Your Health, Anywhere</span>
              </h1>

              <p className="hero-text">
                Connect with verified Nigerian medical specialists in minutes.
                Fund your built-in healthcare wallet, book instant consultations
                from ₦15,000, and receive digital prescriptions with zero hassle.
              </p>

              <div className="hero-cta-group">
                <Button
                  variant="contained"
                  className="btn-primary-consult"
                  startIcon={<VideoCallIcon />}
                  onClick={() => scrollToSection && scrollToSection("wallet")}
                >
                  Start Consultation
                </Button>
                <Button
                  variant="outlined"
                  className="btn-secondary-doctor"
                  startIcon={<VerifiedUserIcon />}
                  onClick={() => scrollToSection && scrollToSection("doctors")}
                >
                  Join as Medical Expert
                </Button>
              </div>

              {/* Stats Bar */}
              <div className="hero-stats-bar">
                <div className="stat-item">
                  <div className="stat-number">50,000+</div>
                  <div className="stat-label">Consultations</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">1,200+</div>
                  <div className="stat-label">Verified Doctors</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number" style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                    4.9 <StarRateRoundedIcon sx={{ color: "#F59E0B", fontSize: 22 }} />
                  </div>
                  <div className="stat-label">Patient Rating</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number" style={{ color: "#10B981" }}>₦20,000</div>
                  <div className="stat-label">Refund Protection</div>
                </div>
              </div>
            </Box>
          </Grid>

          {/* Right Column: Dual Phone Showcase with tele1.png and tele2.png */}
          <Grid item xs={12} md={6}>
            <div className="phones-container">
              <div className="phone-glow" />

              {/* Floating Badge Top Right */}
              <div className="floating-badge badge-top-right">
                <Box
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "10px",
                    bgcolor: "#ECFDF5",
                    color: "#10B981",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AccountBalanceWalletIcon sx={{ fontSize: 22 }} />
                </Box>
                <div>
                  <Typography sx={{ fontSize: "11px", color: "#64748B", fontWeight: 600 }}>
                    Wallet Available Balance
                  </Typography>
                  <Typography sx={{ fontSize: "15px", color: "#0F172A", fontWeight: 800 }}>
                    ₦ 200,000
                  </Typography>
                </div>
              </div>

              {/* Phone Mockup 1: Login & Expert Access */}
              <div className="phone-card-1">
                <img
                  src={tele1}
                  alt="Telemedicine - Login as a Medical Expert"
                  className="phone-mockup-img"
                />
              </div>

              {/* Phone Mockup 2: Digital Health Wallet */}
              <div className="phone-card-2">
                <img
                  src={tele2}
                  alt="Telemedicine - My Wallet and Transactions"
                  className="phone-mockup-img"
                />
              </div>

              {/* Floating Badge Bottom Left */}
              <div className="floating-badge badge-bottom-left">
                <Box
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "10px",
                    bgcolor: "#EFF6FF",
                    color: "#135BEC",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ fontSize: 22 }} />
                </Box>
                <div>
                  <Typography sx={{ fontSize: "11px", color: "#64748B", fontWeight: 600 }}>
                    NIN Verified Doctor
                  </Typography>
                  <Typography sx={{ fontSize: "13.5px", color: "#0F172A", fontWeight: 700 }}>
                    Consultation Ready
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Section1;
